// extracted by mini-css-extract-plugin
export default {"mainContainer":"style_mainContainer__-BsTL","col":"style_col__exjYY","bottomSpace":"style_bottomSpace__u7oVo","question":"style_question__g3vvC","answer":"style_answer__aGDls"};